import React, {useEffect, useState} from "react";
import {getUser, PHP_API} from "../../../utils/Common";
import axios from "axios";
import {Button, Dropdown, Form, Grid, Table} from "semantic-ui-react";

const RpteCosecha = (props) => {

   const [user, _] = useState({...getUser()});
   const [inventario, setInventario] = useState([]);

   useEffect(() => {
      getInventario();
   }, []);

   function getInventario() {
      axios.get(PHP_API + 'get_invcampo_drop')
          .then(r => {
             console.log(r.data);
             setInventario([...r.data.inventario]);
          });
   }

   return (
       <React.Fragment>
          <div className="w-full p-3 right-0">
             <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                   <h5 className="font-bold uppercase text-white">Reporte de Cosecha</h5>
                   {user && <p className="text-white text-sm">Bienvenido, {user.nombre}</p>}
                </div>
                <div className="p-5 rounded-b">
                   {/* ---- CONTENIDO --- */}
                   <Grid style={{marginTop: '10px'}} columns={2} divided>
                      <Grid.Column>
                         <h3>Reportes Registrados</h3>
                         <Table celled>
                            <Table.Header>
                               <Table.Row>
                                  <Table.HeaderCell>Fecha</Table.HeaderCell>
                                  <Table.HeaderCell>Inventario</Table.HeaderCell>
                                  <Table.HeaderCell>Cantidad Tallos</Table.HeaderCell>
                               </Table.Row>
                            </Table.Header>

                         </Table>
                      </Grid.Column>
                      <Grid.Column>
                         <h3>Registro del Reporte</h3>
                         <Form>
                            <Form.Field>
                               <label>Inventario:</label>
                               <Dropdown fluid search name="planid" selection options={inventario} />
                            </Form.Field>
                            <Form.Field>
                               <label htmlFor="">Cantiadad Tallos:</label>
                               <input type="number"/>
                            </Form.Field>
                         </Form>
                         <Button style={{marginTop: '10px'}}>Registrar</Button>
                      </Grid.Column>
                   </Grid>
                </div>
             </div>
          </div>
       </React.Fragment>
   )
}

export default RpteCosecha;